module.exports = __webpack_public_path__ + "img/SFAB.e6f4b6a3.png";